module.exports = __webpack_public_path__ + "img/a6.1df82b9e.png";